import React from 'react'
import { Row, Col, Radio, Space, Checkbox, Popover, Typography } from 'antd'
import { CreateReq } from 'Store/product/types'
import { FormItem } from 'Components/form'
import styled from 'styled-components'
import { Data } from 'Store/delivery-cost/types'
import { EditOutlined, InfoCircleTwoTone } from '@ant-design/icons'
import { TableListPage } from 'Components/common/Table'
import { Theme } from 'Components/common'
import theme, { MyTheme } from 'Components/common/Theme'
import { ActionButton } from 'Components/button'
const { Text } = Typography

type Props = {
  formData: CreateReq
  onUpdateData: (val: any, key: string) => void
  isError: (name: string) => boolean
  deliveryCostData?: Data[]
}

const DeliveryType: React.FunctionComponent<Props> = props => {
  const { formData, onUpdateData, isError, deliveryCostData = [] } = props

  const onUpdateShippingType = (value: any) => {
    onUpdateData(value === 'other_delivery' ? [] : [value], 'shipping_types')
  }

  const onUpdateOtherDelivery = (value: any) => {
    onUpdateData(value || [], 'shipping_types')
  }

  const onSelectDeliveryConfig = (id: any) => {
    onUpdateData(id || 0, 'distance_delivery_config_id')
  }

  let value = ((formData?.shipping_types as string[]) || []).find((val: any) => {
    return val === 'free_delivery' || val === 'special_delivery'
  })

  const popOverContent = (data: Data) => {
    const hasStartPrice = data.delivery_cost_configs[0]?.start_price > 0
    const hasVariablePrice = data.delivery_cost_configs[0]?.variable_price > 0
    const columns = [
      {
        title: 'ระยะทาง',
        dataIndex: 'start',
        key: 'start',
        render: (value: any, record: any) => `${record.start} - ${record.end} กม.`,
        width: '120px',
      },
    ] as any[]

    if (hasStartPrice) {
      columns.push({
        title: hasVariablePrice ? 'ราคาเหมาเริ่มต้น' : 'ราคาเหมา',
        dataIndex: 'start_price',
        key: 'start_price',
        render: (value: any, record: any) => `${record.start_price} บาท`,
      })
    }
    if (hasVariablePrice) {
      columns.push({
        title: 'ราคาต่อระยะทาง 1 กม.',
        dataIndex: 'variable_price',
        key: 'variable_price',
        render: (value: any, record: any) => `${record.variable_price} บาท`,
      })
    }

    return (
      <Table>
        <Text strong>รายละเอียดอัตราค่าขนส่ง</Text>
        <Text strong style={{ color: Theme.colors.primary }}>
          {' '}
          (ระยะทางสูงสุดที่จัดส่ง {data.max_distance} กม.)
        </Text>
        <TableListPage
          columns={columns}
          datas={data.delivery_cost_configs}
          paginationContent={null}
          size="small"
          scrollX={500}
          bordered={true}
        />
      </Table>
    )
  }

  const renderSelectConfigID = (value: number) => {
    return (
      <InputMarginSecond>
        <SpanGrey>
          กรุณาระบุระยะทางจัดส่งสินค้า *หมายเหตุ อัตราค่าขนส่งเป็นไปตามที่ร้านค้ากำหนด &nbsp;
          <a href="/delivery-costs" target="_bank">
            <ActionButton
              text=""
              icon={<EditOutlined />}
              label="จัดการค่าขนส่ง"
              action="edit"
              onClick={() => {}}
            />
          </a>
        </SpanGrey>

        <FormItem
          label=""
          status={isError('distance_delivery_config_id')}
          error={`กรุณาระบุระยะทางจัดส่งสินค้า`}
        >
          <Radio.Group onChange={val => onSelectDeliveryConfig(val.target.value)} value={value}>
            <Space direction="vertical" size="small" wrap={true}>
              {deliveryCostData.map((item, index) => {
                if (item.type !== 'distance') return
                const name = item.is_default ? 'ระยะการส่งมาตรฐาน 50 กม.' : 'ขนส่งแบบพิเศษ'
                return (
                  <Radio value={item.id} key={index}>
                    {name} {!item.is_default && `: ${item.title}`}
                    &nbsp;
                    <Popover content={popOverContent(item)} trigger="hover" placement="right">
                      <InfoCircleTwoTone twoToneColor={theme.colors.primary} />
                    </Popover>
                  </Radio>
                )
              })}
            </Space>
          </Radio.Group>
        </FormItem>
      </InputMarginSecond>
    )
  }

  const renderConfigOtherDelivery = () => {
    return (
      <InputMargin>
        <Checkbox.Group
          disabled={value !== 'other_delivery'}
          value={formData.shipping_types}
          onChange={onUpdateOtherDelivery}
        >
          <Row gutter={[16, 8]}>
            <Col span={24}>
              <Checkbox value="pickup">
                รับสินค้าหน้าร้าน (ลูกค้าสามารถไปรับสินค้าเองที่หน้าร้านได้ โดยไม่เสียค่าจัดส่ง)
              </Checkbox>
            </Col>
            <Col span={24}>
              <Checkbox value="shop_delivery">ร้านค้าจัดส่งเอง (อัตราค่าขนส่งเป็นไปตามที่กำหนด)</Checkbox>
              {formData.shipping_types?.includes('shop_delivery') &&
                renderSelectConfigID(formData.distance_delivery_config_id || 0)}
            </Col>
            <Col span={24}>
              <Checkbox value="public_delivery">
                ขนส่งสาธารณะ (อัตราค่าขนส่งเป็นไปตามขนส่งที่กำหนด เช่น ไปรษณีย์ไทย, BEST Express)
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </InputMargin>
    )
  }

  if (!value) value = 'other_delivery'
  return (
    <Row justify="start">
      <Col md={24} xs={24}>
        <FormItem label="" status={isError('shipping_types')} error="กรุณาเลือก ช่องทางการจัดส่ง">
          <Radio.Group value={value} onChange={val => onUpdateShippingType(val.target.value)}>
            <Space direction="vertical">
              <Radio className="d-flex mt-1" value={'free_delivery'}>
                ส่งฟรี (อยู่ในระยะทาง 50 Km.)
              </Radio>
              <Radio value={'other_delivery'}>ร้านค้ากำหนดค่าจัดส่งเอง</Radio>
              {renderConfigOtherDelivery()}
              <Radio value={'special_delivery'}>สินค้าจัดส่งแบบพิเศษ เช่น รถคอนกรีต</Radio>
              {formData.shipping_types?.includes('special_delivery') &&
                renderSelectConfigID(formData.distance_delivery_config_id || 0)}
            </Space>
          </Radio.Group>
        </FormItem>
      </Col>
    </Row>
  )
}

const InputMargin = styled.div`
  margin-left: 60px;
`

const InputMarginSecond = styled.div`
  margin-left: 30px;
  margin-top: 10px;
`

const Table = styled.div`
  width: 500px;
`

const SpanGrey = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  margin-bottom: 10px;
`

export default DeliveryType
